import { useResetEditingState } from '@/atoms'

import { Form } from './components/Form'

import { useFormData } from './hooks/useFormData'

type Props = {
  orders: uui.domain.client.rm.ExtendedOrderStep[]
}

export function BulkEdit(props: Props) {
  const { orders } = props
  // access form initial values and a function update the data when the form is saved
  const [initialValues, updateOrders] = useFormData(orders)

  const onDiscard = useResetEditingState()

  return (
    <Form
      updateOrders={updateOrders}
      orders={orders}
      initialValues={initialValues}
      onDiscard={onDiscard}
    />
  )
}
